import {reduce, sorted} from '@republic/foundation/lang/array'
import {keys, owns} from '@republic/foundation/lang/object'

const
    settings = {
        Breakpoints: {
            tiny: 550,
            small: 750,
            medium: 960,
            large: 1200,
            huge: 1920,
            extreme: 2500
        },
        Container: {cap: 'medium'},
        Particle: {tag: 'div'},
        Type: {tag: 'div'},
    },

    config = (name, config) => {
        if (name === 'Breakpoints' && !config) {
            return (
                sorted(
                    reduce(
                        keys(settings.Breakpoints),
                        (memo, key) => {
                            memo.push([settings.Breakpoints[key], key])
                            return memo
                        },
                        []),
                    (left, right) => (
                        left[0] > right[0] ? 1 : -1
                    )))
        } else if (owns(settings, name)) {
            if (config) {
                settings[name] = Object.assign(settings[name], config)
            }
            return settings[name]
        }
    }

export {config}
